import { InvitationsQuerySort, useAuthInvitationsLazyQuery, UserInvitationType } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import { InvitationsResultType, UseInvitationsType } from './types';

const useInvitations = (): UseInvitationsType => {
  const [query, queryResult] = useAuthInvitationsLazyQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const request = async (companyId: string) => {
    await query({
      variables: {
        pagination: {
          page: 0,
          pageSize: 100,
        },
        sort: InvitationsQuerySort.IdAsc,
        filters: {
          companyId,
        },
      },
    });
  };

  const result: InvitationsResultType = {
    error: queryResult.error,
    loading: queryResult.loading,
    called: queryResult.called,
    data: {
      items: (queryResult.data?.invitationsPaginationQuery.result || []) as UserInvitationType[],
      paginationInfo: queryResult.data?.invitationsPaginationQuery.paginationInfo,
    },
  };

  return [request, result];
};

export default useInvitations;
